import { Outlet, Link } from "react-router-dom";
import Logo from "./Logo";
import Footer from "./Footer";
import { ArrowRight } from "lucide-react";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#fdfcf7] grid-noise selection:bg-primary selection:text-white">
      {/* 
          NAVBAR: 
          - Three-part layout for perfect centering
          - Thick bottom border 
      */}
      <nav className="sticky top-0 z-50 bg-white border-b-4 border-foreground px-4 md:px-8 py-3">
        <div className="max-w-7xl mx-auto flex items-center">
          
          {/* 1. LEFT SECTION: Logo */}
          <div className="flex-1 flex justify-start">
            <Link to="/" className="group transition-transform active:scale-95">
              <Logo />
            </Link>
          </div>

          {/* 2. CENTER SECTION: Menus (Centered) */}
          <div className="hidden md:flex items-center gap-10">
            <a href="/#features" className="font-black uppercase text-xs tracking-widest hover:text-primary transition-colors">
              Features
            </a>
            <a href="/#pricing" className="font-black uppercase text-xs tracking-widest hover:text-primary transition-colors">
              Pricing
            </a>
            <Link to="/about-us" className="font-black uppercase text-xs tracking-widest hover:text-primary transition-colors">
              About
            </Link>
            <Link to="/contact-us" className="font-black uppercase text-xs tracking-widest hover:text-primary transition-colors">
              Contact
            </Link>
          </div>

          {/* 3. RIGHT SECTION: Login & CTA */}
          <div className="flex-1 flex justify-end items-center gap-6">
            <Link to="/login" className="hidden md:block font-black uppercase text-xs tracking-widest hover:text-primary transition-colors">
              Login
            </Link>
            
            <Link 
              to="/register" 
              className="bg-foreground text-white px-5 py-2 border-2 border-foreground shadow-[4px_4px_0px_0px_rgba(255,92,0,1)] hover:shadow-none hover:translate-x-1 hover:translate-y-1 transition-all font-black uppercase text-xs flex items-center gap-2"
            >
              Get Started <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </nav>

      {/* MAIN CONTENT */}
      <main className="flex-1 w-full overflow-x-hidden">
        <Outlet />
      </main>

      {/* FOOTER */}
      <Footer />
    </div>
  );
}